import React from 'react';
import {
  AppButton,
  DownloadIcon,
  Text,
} from '@common-fe/common-fe';

import { REGEXPS } from '@/common';
import { API_URL } from '@/dtos';
import { downloadFile } from '@/utils/handlers';

interface Props {
  fileId: string;
  fileName: string;
}
const ExportErrorsButton: React.FC<Props> = ({ fileId, fileName }) => {
  const handleDownload = downloadFile(
    API_URL.FILE_FILES_ERRORS_CSV_BY_FILE_ID(fileId),
    fileName.replace(REGEXPS.CSV, '_error_report.csv'),
  );

  return (
    <AppButton
      buttonType="quaternary"
      onClick={handleDownload}
      testId={`download_${fileId}`}
    >
      <Text margin={{ right: 'xs' }}>
        Export CSV
      </Text>
      <DownloadIcon />
    </AppButton>
  );
};

export default ExportErrorsButton;
